import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FilterFieldProps {
  id: string;
  label: string;
  isRequired?: boolean | undefined;
  children: ReactNode;
  className?: string;
}

export function FilterField({
  id,
  label,
  isRequired = false,
  children,
  className,
}: FilterFieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <Label htmlFor={id} className={isRequired ? 'gap-1' : undefined}>
        {label}
        {isRequired ? <span className="text-destructive">*</span> : null}
      </Label>
      {children}
    </div>
  );
}
